import React from "react"
import RestaurantSelected from "../../components/RestaurantSelected/RestaurantSelected"
import "./ConfirmDatePage.scss"

const ConfirmDatePage = () => {
  return (
    <div id="ConfirmDatePage">
      <section className="date-chat-window">
        <RestaurantSelected />
      </section>
    </div>
  )
}

export default ConfirmDatePage
